import { css } from '@emotion/core';
import { Col, Row } from 'antd';
import Link from 'next/link';
import React from 'react';

import Button from '@/src/shared/components/Button';
import Heading from '@/src/shared/components/Heading';
import Sanitize from '@/src/shared/components/Sanitize';
import { bp, colors, space } from '@/styles';
import contentStyle from '@/src/cms/contentStyle';

const styles = {
  container: [
    contentStyle,
    css`
      width: 100%;
      overflow: hidden;
    `
  ],
  header: css`
    font-size: 28px;
    line-height: 36px;
    margin: 0 0 1.8rem;
    @media ${bp.xl} {
      font-size: 36px;
    }
  `,
  content: css`
    font-size: 16px;
    line-height: 28px;
    color: ${colors.secondaryGray};
  `,
  leftDescription: css`
    padding-top: 26px;
    padding-bottom: 0px;
    p {
      padding: 0 !important;
      font-size: 16px;
      line-height: 28px;
      color: ${colors.secondaryGray} !important;
      margin-bottom: 0px;
    }
  `,
  rightJoin: css`
    border-radius: 2px;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    margin-bottom: 20px;
    > img {
      width: 100%;
      height: auto;
    }
  `,
  joinCommittee: css`
    padding: 24px 28px;
  `,
  words: css`
    margin: 20px 0;
    padding: 12px 16px;
    border-left: 6px solid ${colors.primaryRed};
    @media ${bp.md} {
      margin: 20px;
    }
    @media ${bp.xl} {
      margin: 40px 100px;
      padding: 12px 24px;
    }
    p {
      padding: 0;
      color: ${colors.secondaryGrayDark};
    }
    p:first-of-type {
      font-size: 20px;
      line-height: 32px;
      font-weight: 900;
    }
    p:nth-of-type(2) {
      margin-top: 8px;
      font-size: 12px;
      line-height: 20px;
      font-weight: 900;
    }
  `,
  wordsHeader: css`
    line-height: 32px;
  `,
  instruction: css`
    max-width: 780px;
    margin: 40px 0 0;
    @media ${bp.xl} {
      margin: 80px 0 0;
    }
    p {
      padding: 0 !important;
      font-size: 16px;
      line-height: 28px;
      color: ${colors.secondaryGray} !important;
      > strong {
        font-size: 20px;
        line-height: 32px;
        font-weight: 900;
        color: ${colors.secondaryGrayDark};
      }
      &:nth-of-type(odd) {
        margin-top: 32px;
        margin-bottom: 8px;
      }
    }
  `,
};

const CommitteesOverview = ({ pagedata }) => {
  const blockData1 = pagedata.getBlockDataById(50);
  const blockData3 = pagedata.getBlockDataById(52);

  const componentParagraph1 = pagedata.getComponentDataById(98);
  const componentParagraph2 = pagedata.getComponentDataById(100);
  const componentParagraph3 = pagedata.getComponentDataById(103);
  const componentParagraph4 = pagedata.getComponentDataById(104);

  console.log(blockData3, componentParagraph4)
  return (
    <section css={styles.container}>
      {blockData1 && blockData1.BlockTitle ? (
        <Heading type={1} css={styles.header} theme="primaryGray" weight="bolder">
          {blockData1.BlockTitle}
        </Heading>
      ) : null}

      <Row type="flex" gutter={130}>
        {componentParagraph1 && componentParagraph1.Paragraph ? (
          <Col xs={24} md={15} css={styles.leftDescription}>
            <Sanitize>{componentParagraph1.Paragraph}</Sanitize>
          </Col>
        ) : null}

        <Col xs={24} md={9}>
          <div css={styles.rightJoin}>
            {componentParagraph2 && componentParagraph2.ImageId && (
              <img
                src={`${process.env.NEW_API_URL}image/file?area=c&id=${
                  componentParagraph2.ImageId
                }`}
                alt={componentParagraph2.ImageCaption}
              />
            )}

            <div css={styles.joinCommittee}>
              {componentParagraph2 && componentParagraph2.Title ? (
                <Heading type={3} theme="primaryBlue" weight="bolder">
                  {componentParagraph2.Title}
                </Heading>
              ) : null}

              {componentParagraph2 && componentParagraph2.Paragraph ? (
                <div css={[styles.content, space.m.t8, space.m.b16]}>
                  <Sanitize>{componentParagraph2.Paragraph}</Sanitize>
                </div>
              ) : null}

              {componentParagraph2 && componentParagraph2.ButtonUrl ? (
                <a
                  href={componentParagraph2.ButtonUrl}
                  target={
                    componentParagraph2.OpenInNewTab === 'Yes' ||
                    componentParagraph2.OpenInNewTab === 'Y'
                      ? '_blank'
                      : '_self'
                  }
                >
                  <Button theme="default" size="small">
                    {componentParagraph2.ButtonText}
                  </Button>
                </a>
              ) : null}
            </div>
          </div>
        </Col>
      </Row>

      {componentParagraph3 && componentParagraph3.Paragraph ? (
        <div css={styles.words}>
          <Sanitize>{componentParagraph3.Paragraph}</Sanitize>
        </div>
      ) : null}

      {(blockData3 && blockData3.BlockTitle) || (componentParagraph4 && componentParagraph4.Paragraph) ? (
        <div css={styles.instruction}>
          {blockData3 && blockData3.BlockTitle ? (
            <Heading type={1} css={styles.header} theme="primaryGray" weight="bolder">
              {blockData3.BlockTitle}
            </Heading>
          ) : null}

          {componentParagraph4 && componentParagraph4.Paragraph ? (
            <Sanitize>{componentParagraph4.Paragraph}</Sanitize>
          ) : null}
        </div>
      ) : null}
    </section>
  );
};

export default CommitteesOverview;
